import React from "react";
import { PrimaryHeading } from "../../styles";

export default function ShowCaseBanner() {
  return (
    <section className="bg-dark">
      <div className="container">
        <div
          className="m-0 row d-flex align-items-center"
          style={{ minHeight: "400px" }}
        >
          <div className="col-12  text-center">
            <PrimaryHeading className="section-heading display-1 pb-2 pb-sm-3">
              Experience reality like never before with AllesXR.
            </PrimaryHeading>
          </div>
        </div>
      </div>
    </section>
  );
}
